import React, { Component } from 'react';
import DrawerSlideWrapper from './DrawerSlideWrapper';
import SubmitWithLoader from './SubmitWithLoader';

class MenuFixedConfirmSelection extends Component {
  render() {
    const { isRequestOut, hasUpdated, isShown } = this.props;

    return (
      <DrawerSlideWrapper isOpen={isShown} isLeft={true} isButtonOnly={true}>
        <div className="menu-confirm-selection-new__select-wrap">
          <SubmitWithLoader
            formId="submit-dishes-form"
            value="Submit"
            isUpdating={isRequestOut}
            hasUpdated={hasUpdated}
            updatingText="Saving Please Wait"
          ></SubmitWithLoader>
        </div>
      </DrawerSlideWrapper>
    );
  }
}

export default MenuFixedConfirmSelection;



// WEBPACK FOOTER //
// ./src/components/new/MenuFixedConfirmSelection.js